// eslint-disable-next-line import/prefer-default-export
export const SEVERITY_TYPES = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};
